import React from 'react';

import brainIconSrc from './assets/brain.png';
import chartIconSrc from './assets/chart.png';
import moneyBagIconSrc from './assets/money-bag.png';
import screenshot1xSrc from './assets/screenshot@1x.png';
import screenshot2xSrc from './assets/screenshot@2x.png';
import screenshot4xSrc from './assets/screenshot@4x.png';
import starIconSrc from './assets/star.png';
import targetIconSrc from './assets/target.png';
import thunderIconSrc from './assets/thunder.png';
import usersIconSrc from './assets/users.png';

import './stylesheet.scss'

const FEATURES = [
  { iconSrc: thunderIconSrc, label: 'Solve Any Spot in Seconds' },
  { iconSrc: targetIconSrc, label: 'Smart Bet Sizing' },
  { iconSrc: moneyBagIconSrc, label: '$10K Monthly Prizes' },
  { iconSrc: usersIconSrc, label: '45,000+ Players' },
  { iconSrc: brainIconSrc, label: 'AI Feedback' },
  { iconSrc: starIconSrc, label: '92% Recommend' },
  { iconSrc: chartIconSrc, label: 'Track Your Progress' },
];

const GTO_STRATEGY_URL =
  'https://gtostrategy.com?utm_source=odinpoker.io&utm_medium=referral&utm_campaign=odin_cta';

const Placeholder = () => (
  <div className="landing-page container d-flex min-vh-100 align-items-center justify-content-center">
    <div className="placeholder-content text-center">
      <h1 className="main-title">
        We&apos;ve Evolved Into
        <span className="main-title-accent">GTO Strategy</span>
      </h1>
      <p className="main-description">
        Odin Poker is now GTO Strategy. Same team, bigger vision, more powerful poker training platform.
      </p>
      <div className="features-grid">
        {FEATURES.map(({ iconSrc, label }) => (
          <div key={label} className="feature-badge">
            <img className="feature-icon" src={iconSrc} alt="" aria-hidden="true" />
            <span>{label}</span>
          </div>
        ))}
      </div>
      <a href={GTO_STRATEGY_URL} className="cta-link">
        Go to GTO Strategy
      </a>
      <div className="screenshot-wrap">
        <img
          className="screenshot-image"
          src={screenshot1xSrc}
          srcSet={`${screenshot1xSrc} 1x, ${screenshot2xSrc} 2x, ${screenshot4xSrc} 4x`}
          alt="GTO Strategy app screenshot"
        />
      </div>
    </div>
  </div>
);

export default Placeholder;
